"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
document.addEventListener("DOMContentLoaded", function () {
  var tooltips = document.querySelectorAll(".omd-header-tooltip");
  var desktopWidth = 1140;
  (function expandCollapseTooltip() {
    var burger = document.querySelector(".omd-header-burger");
    var profileLink = document.querySelector(".omd-header-profile");
    var profileTooltip = document.querySelector(".omd-header-tooltip");
    var appLink = document.querySelector(".omd-header-my-apps-btn");
    var appTooltip = document.querySelector(".omd-header-apps .omd-header-tooltip--my-apps");
    var accountTooltip = document.querySelector(".omd-header-account .omd-header-tooltip");
    var accountLink = document.querySelector(".omd-header-account-btn");
    var nav = document.querySelector(".omd-header-nav");
    var authAccLink = document.querySelector(".omd-header-apps .omd-header-tooltip--auth-account");
    var accountLinkContainer = document.querySelector(".omd-header-account");
    if (authAccLink && window.innerWidth < desktopWidth) {
      authAccLink.addEventListener("click", function (e) {
        appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.remove("active");
        accountTooltip === null || accountTooltip === void 0 ? void 0 : accountTooltip.classList.remove("active");
        profileTooltip === null || profileTooltip === void 0 ? void 0 : profileTooltip.classList.remove("active");
        authAccLink === null || authAccLink === void 0 ? void 0 : authAccLink.classList.remove("active");
        burger === null || burger === void 0 ? void 0 : burger.classList.remove("active");
        nav === null || nav === void 0 ? void 0 : nav.classList.remove("expanded");
        if (e.target.closest(".omd-header-tooltip-link")) {
          e.preventDefault();
          if (e.target.closest(".omd-header-my-apps-btn")) {
            appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.add("active");
            authAccLink === null || authAccLink === void 0 ? void 0 : authAccLink.classList.remove("active");
          }
          if (e.target.closest(".omd-header-my-account-btn")) {
            accountTooltip === null || accountTooltip === void 0 ? void 0 : accountTooltip.classList.add("active");
            authAccLink === null || authAccLink === void 0 ? void 0 : authAccLink.classList.remove("active");
            accountLinkContainer.classList.add("active");
          }
        }
      });
    }
    if (profileLink) {
      profileLink.addEventListener("click", function () {
        appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.remove("active");
        accountTooltip === null || accountTooltip === void 0 ? void 0 : accountTooltip.classList.remove("active");
        profileTooltip === null || profileTooltip === void 0 ? void 0 : profileTooltip.classList.toggle("active");
        if (window.innerWidth < desktopWidth) {
          authAccLink === null || authAccLink === void 0 ? void 0 : authAccLink.classList.remove("active");
        }
        burger === null || burger === void 0 ? void 0 : burger.classList.remove("active");
        nav === null || nav === void 0 ? void 0 : nav.classList.remove("expanded");
      });
    }
    if (appLink) {
      appLink.addEventListener("click", function () {
        profileTooltip === null || profileTooltip === void 0 ? void 0 : profileTooltip.classList.remove("active");
        accountTooltip === null || accountTooltip === void 0 ? void 0 : accountTooltip.classList.remove("active");
        if (window.innerWidth < desktopWidth) {
          authAccLink === null || authAccLink === void 0 ? void 0 : authAccLink.classList.toggle("active");
          appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.remove("active");
        } else {
          appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.toggle("active");
        }
        burger === null || burger === void 0 ? void 0 : burger.classList.remove("active");
        nav === null || nav === void 0 ? void 0 : nav.classList.remove("expanded");
      });
    }
    if (accountLink) {
      accountLink.addEventListener("click", function () {
        profileTooltip === null || profileTooltip === void 0 ? void 0 : profileTooltip.classList.remove("active");
        appTooltip === null || appTooltip === void 0 ? void 0 : appTooltip.classList.remove("active");
        accountTooltip === null || accountTooltip === void 0 ? void 0 : accountTooltip.classList.toggle("active");
        burger === null || burger === void 0 ? void 0 : burger.classList.remove("active");
        nav === null || nav === void 0 ? void 0 : nav.classList.remove("expanded");
      });
    }
  })();
  (function expandSearchForm() {
    var searchHolders = document.querySelectorAll(".omd-header-search-btn-holder");
    var searchFromContainer = document.querySelector(".omd-header-search-form-container");
    if (searchHolders.length) {
      searchHolders.forEach(function (searchHolder) {
        searchHolder.addEventListener("click", function () {
          searchFromContainer === null || searchFromContainer === void 0 ? void 0 : searchFromContainer.classList.add("active");
          if (tooltips.length) {
            tooltips.forEach(function (item) {
              return item.classList.remove("active");
            });
          }
        });
      });
    }
  })();
  (function closeSearchForm() {
    var searchFromContainer = document.querySelector(".omd-header-search-form-container");
    if (searchFromContainer) {
      var closeSearchBtn = searchFromContainer.querySelector(".omd-header-search-close-btn");
      if (closeSearchBtn) {
        closeSearchBtn.addEventListener("click", function (e) {
          e.preventDefault();
          searchFromContainer.classList.remove("active");
        });
      }
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          searchFromContainer.classList.remove("active");
        }
      });
    }
  })();
  (function searchFunctionality() {
    var searchForm = document.querySelector(".omd-header-search-form");
    if (searchForm) {
      var searchBtn = searchForm.querySelector(".omd-header-search-btn");
      var searchField = searchForm.querySelector(".omd-header-search-form__field");
      searchField.addEventListener("input", function (e) {
        if (e.target.value.length) {
          searchBtn.classList.remove("disabled");
          searchBtn.removeAttribute("disabled");
        } else {
          searchBtn.classList.add("disabled");
          searchBtn.setAttribute("disabled", true);
        }
      });
      if (searchField) {
        searchField.addEventListener("focus", function () {
          searchField.classList.add("active");
        });
        searchField.addEventListener("blur", function () {
          searchField.classList.remove("active");
        });
      }
      searchForm.addEventListener("submit", function (e) {
        e.preventDefault();
        window.location.href = "".concat(searchForm.action, "?q=").concat(encodeURIComponent(searchField.value));
      });
    }
  })();
  (function openCloseHamMenu() {
    var burger = document.querySelector(".omd-header-burger");
    var nav = document.querySelector(".omd-header-nav");
    var overlay = document.querySelector(".jsBgOverlay");
    if (burger && nav) {
      burger.addEventListener("click", function () {
        tooltips.forEach(function (item) {
          return item.classList.remove("active");
        });
        burger.classList.toggle("active");
        nav.classList.toggle("expanded");
        overlay.classList.toggle("isVisible");
      });
    }
  })();
  function initExpand(header) {
    var menus = header.querySelectorAll(".omd-header-nav-list");
    var items = header.querySelectorAll(".omd-header-nav-list-item");
    var initiallyActive = header.querySelector(".omd-header-nav-list-item.active");
    if (initiallyActive) {
      var closestDropdown = initiallyActive.closest(".omd-header-nav-list");
      if (closestDropdown) {
        var expandLevel = closestDropdown.dataset.level;
        if (menus.length) {
          menus.forEach(function (item) {
            if (item.dataset.level <= expandLevel && item.contains(initiallyActive)) {
              item.classList.add("expanded");
            }
          });
          if (items.length) {
            items.forEach(function (item) {
              if (item.querySelector(".omd-header-nav-list-container") && item.classList.contains("active") || item.contains(initiallyActive)) {
                item.classList.add("expanded");
              }
            });
          }
        }
      }
      if (window.innerWidth < desktopWidth) {
        initiallyActive.classList.add("expanded");
      }
    }
  }
  function initExpandOnClick(target, items) {
    if (target.closest(".omd-header-nav-list-item")) {
      var activeItem = target.closest(".omd-header-nav-list-item");
      if (activeItem && !activeItem.children[0].querySelector(".omd-header-acc-btn.hidden")) {
        activeItem.classList.toggle("expanded");
        if (activeItem.classList.contains("hasActiveChilds")) {
          activeItem.classList.remove("hasActiveChilds");
        }
      }
      items.forEach(function (item) {
        return item.classList.remove("active");
      });
      activeItem.classList.add("active");
      if (!activeItem.classList.contains("expanded")) {
        items.forEach(function (item) {
          return item.classList.remove("active");
        });
        // initiallyActive.classList.add("active");
      }
    }
  }

  (function openCloseMenuDropdowns() {
    var menu = document.querySelector(".omd-header");
    if (menu) {
      var listItems = menu.querySelectorAll(".omd-header-nav-list-item");
      // const initiallyActive = menu.querySelector(
      //   ".omd-header-nav-list-item.active"
      // );

      if (listItems.length) {
        if (window.innerWidth >= desktopWidth) {
          listItems.forEach(function (item) {
            item.classList.remove("expanded");
          });
        }
        if (window.innerWidth < desktopWidth) {
          initExpand(menu);
        }
        menu.addEventListener("click", function (e) {
          if (window.innerWidth < desktopWidth) {
            initExpandOnClick(e.target, listItems);
          }
        });
        var itemWithoutChilds = _toConsumableArray(listItems).filter(function (item) {
          return !item.querySelector(".omd-header-nav-list");
        });
        if (itemWithoutChilds) {
          _toConsumableArray(itemWithoutChilds).forEach(function (item) {
            var accBtn = item.querySelector(".omd-header-acc-btn");
            accBtn.classList.add("hidden");
            item.classList.remove("expanded");
          });
        }
      }
    }
  })();
  (function desktopHeaderLinkMouseOver() {
    var header = document.querySelector(".omd-header");
    var menuBackdrop = document.querySelector(".jsDynamicBackdropPanel");
    var overlay = document.querySelector(".jsBgOverlay");
    var activeFstLvItem;
    if (header) {
      var dropdowns = header.querySelectorAll(".omd-header-nav-list-container[data-container = '2']");
      if (dropdowns) {
        dropdowns.forEach(function (dropdown) {
          return dropdown.style.top = "".concat(header.clientHeight - 10, "px");
        });
      }
      if (menuBackdrop && overlay) {
        menuBackdrop.style.top = "".concat(header.clientHeight + 2, "px");
      }
      var navItems = document.querySelectorAll(".omd-header-nav-list[data-level='1'] > .omd-header-nav-list-item");
      if (navItems.length) {
        var _activeFstLvItem;
        var activeChild = document.querySelector(".omd-header-nav-list-item.active");
        if (activeChild) {
          activeFstLvItem = _toConsumableArray(navItems).find(function (item) {
            return item.contains(activeChild);
          });
        }
        (_activeFstLvItem = activeFstLvItem) === null || _activeFstLvItem === void 0 ? void 0 : _activeFstLvItem.classList.add("active");
        _toConsumableArray(navItems).forEach(function (item) {
          if (window.innerWidth >= desktopWidth) {
            item.addEventListener("mousemove", function (e) {
              var _activeFstLvItem2;
              tooltips.forEach(function (item) {
                return item.classList.remove("active");
              });
              _toConsumableArray(navItems).forEach(function (item) {
                return item != e.currentTarget.closest(".omd-header-nav-list-item") && item.classList.remove("opened");
              });
              (_activeFstLvItem2 = activeFstLvItem) === null || _activeFstLvItem2 === void 0 ? void 0 : _activeFstLvItem2.classList.remove("active");
              var currentOpened = e.currentTarget.closest(".omd-header-nav-list-item");
              if (currentOpened) {
                currentOpened.classList.add("opened");
                var openedList = currentOpened.querySelector(".omd-header-nav-list-container");
                menuBackdrop.classList.add("with-all-transition");
                menuBackdrop.style.height = "".concat(openedList.clientHeight, "px");
                menuBackdrop.style.opacity = 1;
                overlay.classList.add("isVisible");
              }
            });
            item.addEventListener("mouseleave", function (e) {
              var _activeFstLvItem3;
              _toConsumableArray(navItems).forEach(function (item) {
                return item.classList.remove("opened");
              });
              (_activeFstLvItem3 = activeFstLvItem) === null || _activeFstLvItem3 === void 0 ? void 0 : _activeFstLvItem3.classList.add("active");
              menuBackdrop.style.height = 0;
              menuBackdrop.style.opacity = 0;
              overlay.classList.remove("isVisible");
            });
          }
        });
      }
    }
  })();
  (function initTabClick() {
    var readerNav = document.querySelector(".omd-screen-reader-nav");
    var logo = document.querySelector(".omd-header-logo");
    if (readerNav) {
      var links = readerNav.querySelectorAll(".omd-screen-reader-link");
      var lastLink = readerNav.querySelector(".omd-screen-reader-item:last-child .omd-screen-reader-link");
      var fstLink = readerNav.querySelector(".omd-screen-reader-item:first-child .omd-screen-reader-link");
      document.addEventListener("keydown", function (e) {
        var activeLink = _toConsumableArray(links).find(function (item) {
          return document.activeElement === item;
        });
        if (e.key === "Tab" && !e.shiftKey) {
          if ((activeLink || readerNav === document.activeElement) && lastLink !== document.activeElement) {
            readerNav.classList.add("focused");
          } else {
            readerNav.classList.remove("focused");
          }
          if (fstLink === document.activeElement) {
            fstLink.classList.remove("highlighted");
          }
        }
        if (e.key === "Tab" && e.shiftKey) {
          if ((activeLink && readerNav !== document.activeElement || document.activeElement === logo) && fstLink !== document.activeElement) {
            readerNav.classList.add("focused");
          } else {
            readerNav.classList.remove("focused");
          }
        }
      });
    }
  })();
  (function backToTop() {
    var backBtn = document.querySelector(".omd-back-top");
    var readerNav = document.querySelector(".omd-screen-reader-nav");
    if (readerNav) {
      var fstLink = readerNav.querySelector(".omd-screen-reader-link");
      if (backBtn) {
        backBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (fstLink) {
            fstLink.focus();
            fstLink.classList.add("highlighted");
            readerNav.classList.add("focused");
          }
        });
      }
    }
  })();
  window.addEventListener("resize", function () {
    var header = document.querySelector(".omd-header");
    if (header) {
      var burger = header.querySelector(".omd-header-burger");
      var headerNav = header.querySelector(".omd-header-nav");
      var listItems = header.querySelectorAll(".omd-header-nav-list-item");
      var buttons = header.querySelectorAll(".omd-header-acc-btn");
      var dropdowns = header.querySelectorAll(".omd-header-nav-list-container[data-container = '2']");
      var accountLinkContainer = document.querySelector(".omd-header-account");
      dropdowns.forEach(function (dropdown) {
        return dropdown.style.top = "".concat(header.clientHeight - 9, "px");
      });
      if (window.innerWidth >= desktopWidth) {
        headerNav === null || headerNav === void 0 ? void 0 : headerNav.classList.remove("expanded");
        if (listItems) {
          listItems.forEach(function (item) {
            return item.classList.remove("expanded");
          });
        }
        burger === null || burger === void 0 ? void 0 : burger.classList.remove("active");
        buttons.forEach(function (item) {
          item.classList.remove("expanded");
        });
        if (accountLinkContainer) {
          accountLinkContainer.classList.remove("active");
        }
      } else {
        initExpand(header);
      }
    }
  });
  document.addEventListener("click", function (e) {
    var overlay = document.querySelector(".jsBgOverlay");
    if (!e.target.closest(".omd-header-tooltip") && !e.target.closest(".omd-header-profile") && !e.target.closest(".omd-header-account-btn") && !e.target.closest(".omd-header-my-apps-btn")) {
      if (tooltips.length) {
        tooltips.forEach(function (item) {
          return item.classList.remove("active");
        });
      }
    } else {
      overlay.classList.remove("isVisible");
    }
  });
  document.addEventListener("click", function (e) {
    var readerNav = document.querySelector(".omd-screen-reader-nav");
    if (readerNav) {
      if (!e.target.closest(".omd-screen-reader-nav-list")) {
        readerNav.classList.remove("focused");
      }
    }
  });
  (function checkActiveChildItem() {
    var fstList = document.querySelector(".omd-header-nav-list");
    var fstListItem = document.querySelector(".omd-header-nav-list > .omd-header-nav-list-item.active");
    var activeItems = fstList.querySelectorAll(".omd-header-nav-list-item.active");
    if (activeItems.length) {
      if (activeItems.length > 1) {
        fstListItem.classList.add("hasActiveChilds");
      } else {
        fstListItem.classList.remove("hasActiveChilds");
      }
    }
  })();
});